<template>
<div>
	<History :historys="history" />
</div>
</template>

<script>
import { mapState } from 'vuex'
import History from '../../../components/history/History'

export default {
	components: {
		History
	},
	computed: {
		...mapState({
			history: ({ workers }) => workers.history
		})
	}
}
</script>
